import { Column } from "@/components/Column";
import { Text } from "@/components/Text";

const FENCE_PICKET_COUNT = 22;
// Pickets lean a little, each its own way, so the fence looks neglected.
const PICKET_TILTS = Array.from(
  { length: FENCE_PICKET_COUNT },
  (_, index) => ((index * 7) % 9) - 4,
);
const GRAVESTONES = [
  { left: 50, top: 59.5, widthCqw: 2.6, epitaph: "R.I.P. Q3 Backlog" },
  { left: 83, top: 58.5, widthCqw: 2, epitaph: null },
];
const CROWS = [
  { left: 56, flip: false },
  { left: 68, flip: true },
  { left: 77, flip: false },
];
const FENCE_TOP_PERCENT = 53.5;

// A crooked picket fence along the ridge, two gravestones in front, and
// crows perched on top until dusk (the bats take over after that).
export const PlayyardHauntedFence = ({ hasCrows }: { hasCrows: boolean }) => {
  return (
    <>
      <svg
        className="pointer-events-none absolute left-[47%] z-[4] h-[4%] w-[40%]"
        style={{ top: `${FENCE_TOP_PERCENT.toString()}%` }}
        viewBox="0 0 220 20"
        preserveAspectRatio="none"
      >
        <rect x="0" y="7" width="220" height="1.6" fill="#3a2a24" />
        <rect x="0" y="13" width="220" height="1.6" fill="#3a2a24" />
        {PICKET_TILTS.map((tilt, index) => {
          const x = 4 + index * 10;
          return (
            <path
              key={x}
              d={`M${x.toString()} 20 L${x.toString()} 3 L${(x + 1.6).toString()} 0 L${(x + 3.2).toString()} 3 L${(x + 3.2).toString()} 20Z`}
              fill="#4a3730"
              transform={`rotate(${tilt.toString()} ${(x + 1.6).toString()} 20)`}
            />
          );
        })}
      </svg>
      {GRAVESTONES.map((stone) => (
        <Column
          key={stone.left}
          className="pointer-events-none absolute z-[5] -translate-x-1/2 -translate-y-full items-center justify-center rounded-t-[45%] bg-gradient-to-b from-[#8b8f99] to-[#5f636d] shadow-[inset_-3px_0_0_rgb(0_0_0_/_0.18)]"
          style={{
            left: `${stone.left.toString()}%`,
            top: `${stone.top.toString()}%`,
            width: `${stone.widthCqw.toString()}cqw`,
            height: `${(stone.widthCqw * 1.25).toString()}cqw`,
          }}
        >
          {stone.epitaph ? (
            <Text className="px-0.5 text-center text-[6px] font-bold uppercase leading-tight tracking-tight text-[#2d3038]">
              {stone.epitaph}
            </Text>
          ) : (
            <Column className="relative h-[40%] w-[12%] bg-[#3f434c] before:absolute before:left-1/2 before:top-[38%] before:h-[12%] before:w-[300%] before:-translate-x-1/2 before:bg-[#3f434c]" />
          )}
        </Column>
      ))}
      {hasCrows
        ? CROWS.map((crow) => (
            <svg
              key={crow.left}
              className="pointer-events-none absolute z-[5] w-[1.6cqw] -translate-x-1/2 -translate-y-[85%]"
              style={{
                left: `${crow.left.toString()}%`,
                top: `${FENCE_TOP_PERCENT.toString()}%`,
              }}
              viewBox="0 0 20 16"
            >
              <path
                d="M2 9 Q6 4 11 5 L14 2 L16 4 L19 4 L16 6 Q16 11 11 12 L10 16 L9 12 Q5 12 2 9Z"
                fill="#15121a"
                transform={crow.flip ? "matrix(-1 0 0 1 20 0)" : undefined}
              />
            </svg>
          ))
        : null}
    </>
  );
};
